import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged } from 'src/app/shared/actions/eliqua.actions';
import {
  CompanyNameChanged,
  CountryCodeChanged,
  CreateMerchant,
  CreatePlainMerchant,
  EmailAddressChanged,
  FirstNameChanged,
  GetCountryCodesSuccess,
  HasLoyaltyFlagChanged,
  LastNameChanged,
  MerchantAppUserChanged,
  MobileChanged,
  SearchMerchantSchemasSuccess,
  SelectedSchemaChanged,
  UserNameChanged,
  VATNumberChanged,
} from '../actions/create-new.actions';
import { MerchantCreateNewState } from '../models/merchant.model';

const initialState: MerchantCreateNewState = {
  companyName: '',
  vatNumber: '',
  firstName: '',
  lastName: '',
  email: '',
  userName: '',
  merchantAppUser: false,
  hasLoyaltyFlag: false,
  schemas: [],
  selectedSchema: '',
  countryCodes: [
    {
      countryId: 0,
      country: '',
      countryCode: '',
      countryCallCode: '',
      mobileNumberValidationPattern: '',
      currency: '',
      currencyCode: '',
      countryLangCode: '',
    },
  ],
  country: '',
  mobile: '',
  submit: false,
};

export const MerchantCreateNewReducer = createReducer(
  initialState,
  on(GetCountryCodesSuccess, (state, { countryCodes }) => ({
    ...state,
    countryCodes,
  })),
  on(SearchMerchantSchemasSuccess, (state, { schemas }) => ({
    ...state,
    schemas,
  })),
  on(CompanyNameChanged, (state, { companyName }) => ({
    ...state,
    companyName,
  })),
  on(VATNumberChanged, (state, { vatNumber }) => ({
    ...state,
    vatNumber,
  })),
  on(FirstNameChanged, (state, { firstName }) => ({
    ...state,
    firstName,
  })),
  on(LastNameChanged, (state, { lastName }) => ({
    ...state,
    lastName,
  })),
  on(EmailAddressChanged, (state, { email }) => ({
    ...state,
    email,
  })),
  on(MerchantAppUserChanged, (state) => ({
    ...state,
    merchantAppUser: !state.merchantAppUser,
  })),
  on(HasLoyaltyFlagChanged, (state, { hasLoyaltyFlag }) => ({
    ...state,
    hasLoyaltyFlag,
  })),
  on(CountryCodeChanged, (state, { country }) => ({
    ...state,
    country,
  })),
  on(MobileChanged, (state, { mobile }) => ({
    ...state,
    mobile,
  })),
  on(UserNameChanged, (state, { userName }) => ({
    ...state,
    userName,
  })),
  on(SelectedSchemaChanged, (state, { selectedSchema }) => ({
    ...state,
    selectedSchema,
  })),
  on(CreateMerchant, CreatePlainMerchant, (state) => ({
    ...state,
    submit: true,
  })),
  on(ActiveComponentChanged, (state) => ({
    ...state,
    companyName: '',
    vatNumber: '',
    firstName: '',
    lastName: '',
    email: '',
    userName: '',
    merchantAppUser: false,
    hasLoyaltyFlag: false,
    country: '',
    schemas: [],
    selectedSchema: '',
    mobile: '',
    submit: false,
  })),
);
